import { ModalProvider as ModalProviderLegacy } from '@panwds/react-ui-legacy'
import { ModalProvider as ModalProviderLatest } from '@panwds/react-ui'
import type { ModalProviderProps } from '@panwds/react-ui'
import type { VFC } from 'react'

const ModalProviders: VFC<ModalProviderProps> = ({ children }) => (
  <ModalProviderLatest>
    <ModalProviderLegacy>
      {children}
    </ModalProviderLegacy>
  </ModalProviderLatest>
)

export default ModalProviders
